import { IonHeader, IonTitle, IonToolbar } from "@ionic/react";
import { Loader } from "components";

import { FilterBar } from "~components/Organisms/IndexFilters";
import { initialLocalStorageFilterValues } from "~components/Organisms/IndexFilters/types";
import { translate, useLocalStorage } from "~utils";

import { useRequestIndexFilters, useRequests } from "./hooks";
import { RequestCount } from "./RequestCount";
import { RequestIndex } from "./RequestIndex";

export function PastRequestsPage() {
  const { data, isError } = useRequests({
    showHistory: true,
  });

  const [ls, setLs] = useLocalStorage(
    "swing-schools:filters:past",
    initialLocalStorageFilterValues,
  );

  const filteredRequests = useRequestIndexFilters(ls, data?.requests);

  if (!data) return <Loader />;

  return (
    <>
      <IonHeader collapse="condense">
        <IonToolbar>
          <IonTitle size="large">{translate("ROUTE_TABLE_PAST_REQUESTS")}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <FilterBar page="past" ls={ls} setLs={setLs} />
      <RequestCount page="past" count={filteredRequests.length} />
      <RequestIndex requestType="past-requests" requests={filteredRequests} isError={isError} />
    </>
  );
}
